import { useEffect, useState } from 'react';

import { LookupAutocompleteView } from '@/shared/ui/molecules/LookupAutocomplete';

import { useCompanySearchDropdown } from '../../../hooks/useCompanySearchDropdown';

export interface CompanyAutocompleteProps {
  /** ID da empresa selecionada; `null` quando nada. */
  readonly value: number | null;
  /** Rótulo da seleção corrente. */
  readonly selectedLabel?: string;
  /** Notifica o novo ID e rótulo (`null`/`''` ao limpar). */
  readonly onChange: (id: number | null, label: string) => void;
  readonly label: string;
  readonly placeholder: string;
}

/**
 * Autocomplete de Empresa para o filtro "Empresa" da listagem de Banner
 * (busca server-side via {@link useCompanySearchDropdown}, base compartilhada
 * `LookupAutocompleteView`).
 */
export function CompanyAutocomplete({
  value,
  selectedLabel: selectedLabelProp = '',
  onChange,
  label,
  placeholder,
}: CompanyAutocompleteProps) {
  const [search, setSearch] = useState('');
  const [inputText, setInputText] = useState(selectedLabelProp);
  const { options, isQuerySuccess } = useCompanySearchDropdown(search);

  useEffect(() => {
    setInputText(selectedLabelProp);
  }, [selectedLabelProp]);

  return (
    <LookupAutocompleteView
      label={label}
      placeholder={placeholder}
      value={value !== null ? String(value) : ''}
      selectedLabel={inputText}
      options={options}
      isQuerySuccess={isQuerySuccess}
      search={search}
      onSearchChange={setSearch}
      onSelect={(id, itemLabel) => {
        onChange(id ? Number(id) : null, itemLabel);
        setInputText(itemLabel);
        setSearch('');
      }}
      onClear={() => {
        onChange(null, '');
        setInputText('');
        setSearch('');
      }}
    />
  );
}
